/* eslint-disable @next/next/no-img-element */
import type { WebflowArticle } from '@/utils/hooks/swr/useWebflowArticles';
// Hooks
import useWebflowArticles from '@/utils/hooks/swr/useWebflowArticles';
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { PlatformLanguagesType } from '@/types/userType';

// Components
import Icon from '@/components/base/Icon';

const MAX_ITEMS_DISPLAY = 3;

const LatestUpdatesItem = ({ item }: { item: WebflowArticle }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center space-x-2">
            {item?.image_url ? (
                <img
                    className="relative h-15 w-20 rounded-md object-cover"
                    src={item.image_url}
                    alt={item?.title ?? ''}
                    width={160}
                    height={120}
                />
            ) : null}
            <div className="flex flex-col space-y-2">
                <p className="line-clamp-3 text-xs text-icoBlack">{item?.title}</p>
                <div className="flex items-center space-x-1">
                    <a
                        href={item?.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xxs text-icoBlue">
                        {t('signin:latest_updates.read_full_update')}
                    </a>
                    <Icon icon="arrow-left" className="rotate-180 text-xxs text-icoBlue" />
                </div>
            </div>
        </div>
    );
};

const LatestUpdates = () => {
    const { t, lang } = useTranslation();

    // Product latest updates
    const { articles, isLoading, articlesError } = useWebflowArticles({
        params: {
            article_types: ['product_update'],
            article_count: MAX_ITEMS_DISPLAY,
            lang: lang as PlatformLanguagesType
        }
    });

    if (isLoading || articlesError) return null;

    return (
        <div className="w-64 rounded-xl bg-white p-5" data-testid="latest-updates">
            <div className="mb-5 flex items-center gap-2">
                <Icon icon="reports" className="rotate-180 text-sm text-icoBlue" />
                <p className="text-sm text-icoBlack">
                    {t('signin:latest_updates.latest_updates')}
                    <span className="ml-1 text-xxs">🚀</span>
                </p>
            </div>
            <div className="flex flex-col gap-3">
                {articles.map((item) => (
                    <LatestUpdatesItem key={item?.title} item={item} />
                ))}
            </div>
        </div>
    );
};

export default LatestUpdates;
